import { ArrowUpRight } from 'lucide-react'
import heroArtwork from '../assets/measurement-hero.webp'

export default function Hero({ copy }) {
  return (
    <section className="hero" aria-labelledby="page-title">
      <div className="hero-copy">
        <h1 id="page-title">{copy.heroTitleBefore} <span>{copy.heroTitleAccent}</span>,<br />{copy.heroTitleAfter}</h1>
        <p>{copy.heroCopy}</p>
        <a className="story-link" href="https://www.guidebg.com/in-the-measures-of-mankind/" target="_blank" rel="noreferrer">
          {copy.readStory} <ArrowUpRight aria-hidden="true" size={18} />
        </a>
      </div>
      <div className="hero-art" aria-hidden="true">
        <img src={heroArtwork} alt="" width="1536" height="1024" fetchPriority="high" decoding="async" />
      </div>
    </section>
  )
}
